export function formatListConjunction(list: string[]) {
  const formatter = new Intl.ListFormat("en-GB", {
    type: "conjunction",
  });
  return formatter.format(list);
}
